"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowSidebarSticky = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importStar)(require("styled-components"));
function FlowSidebar(_a) {
    var children = _a.children;
    return react_1.default.createElement(StyledSidebar, null, children);
}
exports.default = FlowSidebar;
function FlowSidebarSticky(_a) {
    var children = _a.children, offset = _a.offset;
    var _b = (0, react_1.useState)(false), isSticky = _b[0], setSticky = _b[1];
    var _c = (0, react_1.useState)(null), leftPosition = _c[0], setLeftPosition = _c[1];
    var _d = (0, react_1.useState)(null), topPosition = _d[0], setTopPosition = _d[1];
    var stickyOffset = offset || 155;
    var ref = (0, react_1.useRef)(null);
    var handleScroll = function () {
        var windowScrollPosition = window.scrollY;
        setSticky(windowScrollPosition > stickyOffset);
        if (ref && ref.current) {
            setLeftPosition(ref.current.getBoundingClientRect().left);
            setTopPosition(stickyOffset);
        }
    };
    var handleResize = function () {
        setSticky(false);
        setLeftPosition(null);
        setTopPosition(null);
    };
    (0, react_1.useEffect)(function () {
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('scroll', function () { return handleScroll; });
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return (react_1.default.createElement("div", { className: isSticky ? 'sticky' : '' },
        react_1.default.createElement(StyledSidebar, { ref: ref, left: leftPosition, top: topPosition }, children)));
}
exports.FlowSidebarSticky = FlowSidebarSticky;
var fadeSidebarIn = (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  to {\n    opacity: 1;\n  }\n"], ["\n  to {\n    opacity: 1;\n  }\n"])));
var StyledSidebar = styled_components_1.default.div(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  left: -250px;\n  position: absolute;\n  top: 0;\n  width: 220px;\n\n  .sticky & {\n    animation: ", " 0.8s 0.8s ease forwards;\n    opacity: 0;\n    position: fixed;\n    width: 220px;\n    ", ";\n    ", ";\n  }\n"], ["\n  left: -250px;\n  position: absolute;\n  top: 0;\n  width: 220px;\n\n  .sticky & {\n    animation: ", " 0.8s 0.8s ease forwards;\n    opacity: 0;\n    position: fixed;\n    width: 220px;\n    ", ";\n    ", ";\n  }\n"])), fadeSidebarIn, function (_a) {
    var left = _a.left;
    return left && "left: ".concat(left, "px");
}, function (_a) {
    var top = _a.top;
    return top && "top: ".concat(top, "px");
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=flow-sidebar.js.map